<template>
<div class="xiannong-home">
    <!-- 田园风格Banner -->
    <div class="farm-hero">
        <div class="hero-content">
            <h1>闲农日季</h1>
            <p class="hero-subtitle">记录乡野生活，分享田园时光</p>
            <div class="hero-buttons">
                <button class="primary-btn" @click="$router.push('/diary')">查看日记</button>
                <button class="secondary-btn" @click="$router.push('/garden')">我的菜园</button>
            </div>
        </div>
        <div class="nature-elements">
            <div class="leaf" v-for="i in 15" :key="i" :style="getLeafStyle(i)"></div>
            <div class="sun"></div>
            <div class="cloud"></div>
            <div class="bird" v-for="i in 3" :key="'bird'+i" :style="getBirdStyle(i)"></div>
        </div>
    </div>

    <!-- 最新日记 -->
    <div class="section diary-section">
        <div class="container">
            <h2 class="section-title">最新<span class="highlight">日记</span></h2>
            <p class="section-subtitle">记录生活的美好瞬间</p>
            <div class="diary-grid">
                <div class="diary-card" v-for="diary in latestDiaries" :key="diary.id">
                    <div class="diary-image" :class="diary.season">
                        <div class="season-badge">{{ diary.season }}</div>
                    </div>
                    <div class="diary-content">
                        <h3>{{ diary.title }}</h3>
                        <p class="diary-excerpt">{{ diary.excerpt }}</p>
                        <div class="diary-meta">
                            <span><i class="icon">☀️</i> {{ diary.weather }}</span>
                            <span><i class="icon">😊</i> {{ diary.mood }}</span>
                            <span><i class="icon">📅</i> {{ diary.date }}</span>
                        </div>
                        <button class="read-btn" @click="$router.push(diary.link)">阅读全文</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 我的菜园 -->
    <div class="section garden-section">
        <div class="container">
            <div class="garden-container">
                <div class="garden-content">
                    <h2 class="section-title">我的<span class="highlight">菜园</span></h2>
                    <p class="section-subtitle">亲手种植，收获喜悦</p>
                    <div class="garden-text">
                        <p>在这片小小的土地上，我种下了希望，收获了快乐。每一颗蔬菜都是自然的馈赠。</p>
                        <p>从播种到收获，记录着生命的成长，感受着季节的变迁。</p>
                    </div>
                    <div class="garden-stats">
                        <div class="garden-stat" v-for="stat in gardenStats" :key="stat.label">
                            <div class="stat-icon">{{ stat.icon }}</div>
                            <div class="stat-number">{{ stat.number }}</div>
                            <div class="stat-label">{{ stat.label }}</div>
                        </div>
                    </div>
                    <button class="primary-btn" @click="$router.push('/garden')">查看菜园</button>
                </div>
                <div class="garden-visual">
                    <div class="garden-bed">
                        <div class="plant tomato"></div>
                        <div class="plant cucumber"></div>
                        <div class="plant lettuce"></div>
                        <div class="plant carrot"></div>
                    </div>
                    <div class="garden-tags">
                        <span v-for="tag in gardenTags" :key="tag">{{ tag }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 季节记录 -->
    <div class="section season-section">
        <div class="container">
            <h2 class="section-title">四季<span class="highlight">记录</span></h2>
            <p class="section-subtitle">感受季节的轮回与变迁</p>
            <div class="season-cards">
                <div class="season-card" v-for="season in seasons" :key="season.name">
                    <div class="season-icon" :style="{backgroundColor: season.color}">
                        <div class="season-symbol">{{ season.symbol }}</div>
                    </div>
                    <h3>{{ season.name }}</h3>
                    <p class="season-desc">{{ season.description }}</p>
                    <div class="season-count">
                        <span><i class="icon">📝</i> {{ season.diaries }}篇日记</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 今日农事 -->
    <div class="section farming-section">
        <div class="container">
            <h2 class="section-title">今日<span class="highlight">农事</span></h2>
            <p class="section-subtitle">今天的田园工作记录</p>
            <div class="farming-list">
                <div class="farming-item" v-for="task in farmingTasks" :key="task.id">
                    <div class="task-icon">
                        <div class="task-symbol">{{ task.symbol }}</div>
                    </div>
                    <div class="task-content">
                        <h4>{{ task.title }}</h4>
                        <p>{{ task.description }}</p>
                        <span class="task-time">{{ task.time }}</span>
                    </div>
                    <div class="task-status" :class="task.status">
                        {{ task.status === 'completed' ? '✅ 已完成' : '⏳ 进行中' }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 月度收获 -->
    <div class="section harvest-section">
        <div class="container">
            <h2 class="section-title">本月<span class="highlight">收获</span></h2>
            <p class="section-subtitle">辛勤劳动换来的丰收</p>
            <div class="harvest-chart">
                <div class="harvest-item" v-for="item in harvestItems" :key="item.name">
                    <div class="veggie-icon">{{ item.icon }}</div>
                    <div class="veggie-info">
                        <div class="veggie-name">{{ item.name }}</div>
                        <div class="veggie-amount">{{ item.amount }}</div>
                    </div>
                    <div class="veggie-bar" :style="{width: item.percentage + '%'}"></div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'XiannongHome',
    data() {
        return {
            latestDiaries: [
                {
                    id: 1,
                    title: '雨后初晴的菜园',
                    excerpt: '昨夜的雨洗净了尘埃，今晨的菜园格外清新。西红柿红得发亮，黄瓜藤上挂满了露珠，一切都是那么生机勃勃...',
                    season: 'spring',
                    date: '3月15日',
                    weather: '晴',
                    mood: '愉悦',
                    link: '/diary/1'
                },
                {
                    id: 2,
                    title: '收获的季节',
                    excerpt: '今天收获了第一批土豆，泥土的芬芳混着土豆的清香，这就是收获的味道。孩子们兴奋地在田地里寻找最大的那一颗...',
                    season: 'summer',
                    date: '3月14日',
                    weather: '多云',
                    mood: '满足',
                    link: '/diary/2'
                },
                {
                    id: 3,
                    title: '春日播种',
                    excerpt: '在温暖的春风中，种下了四季豆和黄瓜的种子。轻轻覆盖上松软的泥土，洒上清水，期待它们破土而出的那一刻...',
                    season: 'spring',
                    date: '3月13日',
                    weather: '晴',
                    mood: '期待',
                    link: '/diary/3'
                }
            ],
            gardenStats: [
                { icon: '🍅', number: '8', label: '种植品种' },
                { icon: '📅', number: '156', label: '生长天数' },
                { icon: '⚖️', number: '24.5kg', label: '今年收获' },
                { icon: '🌱', number: '100%', label: '有机种植' }
            ],
            gardenTags: ['有机蔬菜', '家庭菜园', '自给自足', '绿色生活'],
            seasons: [
                {
                    name: '春',
                    symbol: '🌸',
                    description: '播种希望，万物复苏的季节',
                    color: '#FFCDD2',
                    diaries: '42篇'
                },
                {
                    name: '夏',
                    symbol: '🌞',
                    description: '生长旺盛，收获初果的季节',
                    color: '#FFF9C4',
                    diaries: '38篇'
                },
                {
                    name: '秋',
                    symbol: '🍂',
                    description: '丰收喜悦，果实累累的季节',
                    color: '#FFCC80',
                    diaries: '45篇'
                },
                {
                    name: '冬',
                    symbol: '❄️',
                    description: '休养生息，规划来年的季节',
                    color: '#B3E5FC',
                    diaries: '36篇'
                }
            ],
            farmingTasks: [
                {
                    id: 1,
                    title: '浇水施肥',
                    description: '为西红柿和黄瓜浇水，施有机肥',
                    symbol: '💦',
                    time: '早晨7:00',
                    status: 'completed'
                },
                {
                    id: 2,
                    title: '除草松土',
                    description: '清除菜园杂草，松土透气',
                    symbol: '🌿',
                    time: '上午9:00',
                    status: 'completed'
                },
                {
                    id: 3,
                    title: '采摘收获',
                    description: '采摘成熟的西红柿和生菜',
                    symbol: '🧺',
                    time: '下午4:00',
                    status: 'in-progress'
                }
            ],
            harvestItems: [
                { icon: '🍅', name: '西红柿', amount: '5.2kg', percentage: 85 },
                { icon: '🥒', name: '黄瓜', amount: '4.8kg', percentage: 78 },
                { icon: '🥬', name: '生菜', amount: '3.5kg', percentage: 68 },
                { icon: '🥕', name: '胡萝卜', amount: '2.8kg', percentage: 55 },
                { icon: '🌶️', name: '辣椒', amount: '1.6kg', percentage: 42 }
            ]
        }
    },
    methods: {
        getLeafStyle() {
            const size = 20 + Math.random() * 30
            const rotation = Math.random() * 360
            const left = Math.random() * 100
            const top = Math.random() * 100
            const delay = Math.random() * 5
            
            return {
                width: `${size}px`,
                height: `${size}px`,
                transform: `rotate(${rotation}deg)`,
                left: `${left}%`,
                top: `${top}%`,
                animationDelay: `${delay}s`,
                opacity: 0.3 + Math.random() * 0.4
            }
        },
        getBirdStyle() {
            const left = 10 + Math.random() * 80
            const top = 10 + Math.random() * 50
            const delay = Math.random() * 3
            
            return {
                left: `${left}%`,
                top: `${top}%`,
                animationDelay: `${delay}s`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.xiannong-home {
    font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
    color: #5a3921;
    background: linear-gradient(to bottom, #f9f7f0 0%, #e8f5e8 100%);
    min-height: 100vh;
}

.farm-hero {
    height: 500px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: linear-gradient(135deg, #a8e6cf 0%, #dcedc1 50%, #ffd3b6 100%);

    .hero-content {
        position: relative;
        z-index: 4;
        max-width: 800px;
        padding: 0 20px;
        
        h1 {
            font-size: 52px;
            margin: 0 0 15px;
            font-weight: 600;
            color: #2e7d32;
            text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.8);
            font-family: 'KaiTi', 'STKaiti', serif;
        }

        .hero-subtitle {
            font-size: 22px;
            margin: 0 0 40px;
            color: #558b2f;
            opacity: 0.9;
        }
    }

    .nature-elements {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        pointer-events: none;

        .leaf {
            position: absolute;
            background: linear-gradient(45deg, #81c784, #4caf50);
            clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
            opacity: 0.4;
            animation: float 15s infinite linear;
        }

        .sun {
            position: absolute;
            top: 20%;
            right: 15%;
            width: 60px;
            height: 60px;
            background: radial-gradient(circle, #FFEB3B, #FF9800);
            border-radius: 50%;
            box-shadow: 0 0 40px rgba(255, 152, 0, 0.5);
            animation: float 20s infinite ease-in-out;
        }

        .cloud {
            position: absolute;
            top: 30%;
            left: 20%;
            width: 80px;
            height: 40px;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 50px;
            animation: float 25s infinite linear;

            &::before, &::after {
                content: '';
                position: absolute;
                background: rgba(255, 255, 255, 0.9);
                border-radius: 50%;
            }

            &::before {
                width: 40px;
                height: 40px;
                top: -15px;
                left: 10px;
            }

            &::after {
                width: 50px;
                height: 50px;
                top: -20px;
                right: 10px;
            }
        }

        .bird {
            position: absolute;
            width: 30px;
            height: 20px;
            background: transparent;
            
            &::before {
                content: '🐦';
                font-size: 24px;
                animation: fly 8s infinite linear;
            }
        }
    }
}

@keyframes float {
    0%, 100% {
        transform: translateY(0) rotate(0deg);
    }
    50% {
        transform: translateY(-20px) rotate(10deg);
    }
}

@keyframes fly {
    0% {
        transform: translateX(0) scaleX(1);
    }
    50% {
        transform: translateX(100px) scaleX(1);
    }
    51% {
        transform: translateX(100px) scaleX(-1);
    }
    100% {
        transform: translateX(0) scaleX(-1);
    }
}

.hero-buttons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;

    button {
        padding: 12px 32px;
        border-radius: 25px;
        border: none;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        min-width: 150px;
    }

    .primary-btn {
        background: linear-gradient(135deg, #81c784, #4caf50);
        color: white;
        box-shadow: 0 4px 15px rgba(129, 199, 132, 0.3);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(129, 199, 132, 0.4);
        }
    }

    .secondary-btn {
        background: white;
        color: #4caf50;
        border: 2px solid #81c784;

        &:hover {
            background: #f1f8e9;
            transform: translateY(-2px);
        }
    }
}

.section {
    padding: 80px 0;

    &.diary-section {
        background: #f9f7f0;
    }

    &.garden-section {
        background: white;
    }

    &.season-section {
        background: #f1f8e9;
    }

    &.farming-section {
        background: white;
    }

    &.harvest-section {
        background: #f9f7f0;
    }
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.section-title {
    text-align: center;
    font-size: 36px;
    color: #5a3921;
    margin-bottom: 10px;
    font-weight: 600;

    .highlight {
        color: #4caf50;
        position: relative;
        
        &::after {
            content: '';
            position: absolute;
            bottom: 2px;
            left: 0;
            width: 100%;
            height: 6px;
            background: rgba(129, 199, 132, 0.3);
            z-index: -1;
            border-radius: 3px;
        }
    }
}

.section-subtitle {
    text-align: center;
    font-size: 18px;
    color: #8d6e63;
    margin-bottom: 50px;
}

.diary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    margin-top: 30px;
}

.diary-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 5px 20px rgba(139, 195, 74, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 30px rgba(139, 195, 74, 0.15);
    }
}

.diary-image {
    height: 180px;
    position: relative;
    overflow: hidden;

    &.spring {
        background: linear-gradient(45deg, #C8E6C9, #A5D6A7);
    }
    
    &.summer {
        background: linear-gradient(45deg, #FFF9C4, #FFE082);
    }
    
    &.autumn {
        background: linear-gradient(45deg, #FFE0B2, #FFCC80);
    }
    
    &.winter {
        background: linear-gradient(45deg, #B3E5FC, #81D4FA);
    }

    .season-badge {
        position: absolute;
        top: 15px;
        right: 15px;
        background: rgba(255, 255, 255, 0.9);
        padding: 5px 15px;
        border-radius: 20px;
        font-size: 14px;
        color: #4caf50;
        font-weight: 500;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
}

.diary-content {
    padding: 20px;

    h3 {
        font-size: 20px;
        margin: 0 0 10px;
        color: #5a3921;
        font-weight: 600;
    }

    .diary-excerpt {
        color: #8d6e63;
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 15px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        min-height: 66px;
    }
}

.diary-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 15px;
    font-size: 14px;
    color: #a1887f;

    span {
        display: flex;
        align-items: center;
        gap: 5px;

        .icon {
            font-size: 16px;
        }
    }
}

.read-btn {
    width: 100%;
    padding: 10px;
    background: #f1f8e9;
    border: none;
    border-radius: 6px;
    color: #4caf50;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: #e8f5e8;
    }
}

.garden-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    align-items: center;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 30px;
    }
}

.garden-visual {
    .garden-bed {
        width: 100%;
        height: 250px;
        background: linear-gradient(to bottom, #8D6E63, #5D4037);
        border-radius: 15px;
        position: relative;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(139, 195, 74, 0.2);

        .plant {
            position: absolute;
            bottom: 0;

            &.tomato {
                left: 20%;
                width: 60px;
                height: 80px;
                background: #FF5252;
                border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;

                &::after {
                    content: '';
                    position: absolute;
                    top: -20px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 40px;
                    height: 40px;
                    background: #FF5252;
                    border-radius: 50%;
                    box-shadow: 0 0 0 8px rgba(255, 82, 82, 0.3);
                }
            }

            &.cucumber {
                left: 40%;
                width: 30px;
                height: 60px;
                background: #8BC34A;
                border-radius: 20px;

                &::after {
                    content: '';
                    position: absolute;
                    top: -15px;
                    left: 0;
                    width: 100%;
                    height: 30px;
                    background: #8BC34A;
                    border-radius: 15px;
                }
            }

            &.lettuce {
                left: 60%;
                width: 50px;
                height: 40px;
                background: #4CAF50;
                border-radius: 50%;

                &::before {
                    content: '';
                    position: absolute;
                    top: -15px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 40px;
                    height: 30px;
                    background: #4CAF50;
                    border-radius: 50%;
                }
            }

            &.carrot {
                left: 80%;
                width: 20px;
                height: 50px;
                background: #FF9800;
                border-radius: 10px;
            }
        }
    }

    .garden-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 20px;

        span {
            background: #f1f8e9;
            padding: 6px 15px;
            border-radius: 20px;
            font-size: 14px;
            color: #4caf50;
            border: 1px solid #c8e6c9;
        }
    }
}

.garden-text {
    color: #8d6e63;
    line-height: 1.8;
    margin-bottom: 30px;
    font-size: 16px;

    p {
        margin-bottom: 15px;
    }
}

.garden-stats {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin: 30px 0;

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
}

.garden-stat {
    background: #f1f8e9;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(129, 199, 132, 0.2);
    }

    .stat-icon {
        font-size: 32px;
        margin-bottom: 10px;
    }

    .stat-number {
        font-size: 24px;
        font-weight: 700;
        color: #4caf50;
        margin-bottom: 5px;
    }

    .stat-label {
        font-size: 14px;
        color: #8d6e63;
    }
}

.season-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
    margin-top: 40px;
}

.season-card {
    background: white;
    border-radius: 12px;
    padding: 30px;
    text-align: center;
    box-shadow: 0 5px 20px rgba(139, 195, 74, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(139, 195, 74, 0.15);
    }
}

.season-icon {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;

    .season-symbol {
        font-size: 36px;
    }
}

.season-card h3 {
    font-size: 22px;
    margin: 0 0 10px;
    color: #5a3921;
}

.season-desc {
    color: #8d6e63;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 15px;
    min-height: 42px;
}

.season-count {
    font-size: 14px;
    color: #a1887f;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.farming-list {
    max-width: 600px;
    margin: 30px auto 0;
}

.farming-item {
    background: white;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 20px;
    box-shadow: 0 3px 15px rgba(139, 195, 74, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateX(5px);
        box-shadow: 0 5px 20px rgba(139, 195, 74, 0.15);
    }
}

.task-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #f1f8e9;
    display: flex;
    align-items: center;
    justify-content: center;

    .task-symbol {
        font-size: 24px;
    }
}

.task-content {
    flex: 1;

    h4 {
        margin: 0 0 5px;
        color: #5a3921;
        font-size: 16px;
    }

    p {
        margin: 0 0 5px;
        color: #8d6e63;
        font-size: 14px;
    }

    .task-time {
        font-size: 12px;
        color: #a1887f;
    }
}

.task-status {
    padding: 6px 15px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;

    &.completed {
        background: #e8f5e9;
        color: #4caf50;
    }

    &.in-progress {
        background: #fff3e0;
        color: #ff9800;
    }
}

.harvest-chart {
    max-width: 600px;
    margin: 40px auto 0;
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 5px 20px rgba(139, 195, 74, 0.1);
}

.harvest-item {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    position: relative;

    &:last-child {
        margin-bottom: 0;
    }

    .veggie-icon {
        font-size: 32px;
        margin-right: 15px;
        width: 40px;
        text-align: center;
    }

    .veggie-info {
        flex: 1;
    }

    .veggie-name {
        font-weight: 600;
        color: #5a3921;
        margin-bottom: 3px;
    }

    .veggie-amount {
        font-size: 12px;
        color: #8d6e63;
    }

    .veggie-bar {
        position: absolute;
        right: 0;
        height: 8px;
        background: linear-gradient(90deg, #C8E6C9, #4CAF50);
        border-radius: 4px;
        transition: width 1s ease;
    }
}

@media (max-width: 768px) {
    .farm-hero {
        height: 400px;

        h1 {
            font-size: 36px;
        }

        .hero-subtitle {
            font-size: 18px;
            margin-bottom: 30px;
        }
    }

    .hero-buttons {
        flex-direction: column;
        gap: 15px;

        button {
            width: 100%;
        }
    }

    .section {
        padding: 60px 0;
    }

    .section-title {
        font-size: 28px;
    }

    .section-subtitle {
        font-size: 16px;
        margin-bottom: 30px;
    }

    .garden-container {
        grid-template-columns: 1fr;
    }

    .farming-item {
        flex-direction: column;
        text-align: center;
        gap: 15px;
    }

    .harvest-chart {
        padding: 20px;
    }
}

@media (max-width: 480px) {
    .farm-hero {
        height: 350px;

        h1 {
            font-size: 28px;
        }

        .hero-subtitle {
            font-size: 16px;
        }

        .nature-elements {
            .sun {
                width: 40px;
                height: 40px;
                right: 10%;
            }
        }
    }

    .diary-grid {
        grid-template-columns: 1fr;
    }

    .season-cards {
        grid-template-columns: 1fr;
    }

    .garden-bed {
        height: 200px;
    }
}
</style>